export const DATA_UPLOAD = 'DATA_UPLOAD'
export const DATA_UPLOAD_FAILURE = 'DATA_UPLOAD_FAILURE'
export const DATA_UPLOAD_SUCCESS = 'DATA_UPLOAD_SUCCESS'

export const dataUpload = (data) => {
    return {
        type: DATA_UPLOAD,
        data
    }
}

export const dataUploadFailure  = (data) => {
    return {
        type: DATA_UPLOAD_FAILURE,
        data
    }
}
export const dataUploadSuccess = (data) => {
    return {
        type: DATA_UPLOAD_SUCCESS,
        data
    }
}

export const GET_DATA_LIST = 'GET_DATA_LIST';
export const GET_DATA_LIST_SUCCESS = 'GET_DATA_LIST_SUCCESS';
export const GET_DATA_LIST_FAILURE = 'GET_DATA_LIST_FAILURE';

export const getDataListSuccess = (data) => {
    return {
        type: GET_DATA_LIST_SUCCESS,
        data
    }
}
export const getDataList = (data) => {
    return {
        type: GET_DATA_LIST,
        data
    }
}
export const getDataListFailure = (data) => {
    return {
        type: GET_DATA_LIST_FAILURE,
        data
    }
}

export const DOWNLOAD_STAR_RATING_RESULT = 'DOWNLOAD_STAR_RATING_RESULT';

export const downloadStarRatingResult = (recordId, fileName) => ({
    type: DOWNLOAD_STAR_RATING_RESULT,
    recordId,
    fileName,
});
